module.exports = __webpack_public_path__ + "static/media/send.006d060e.svg";